import styled from 'styled-components';

interface HiddenCheckboxProps {
  height?: string;
  width?: string;
}

export const HiddenCheckbox = styled.input.attrs<HiddenCheckboxProps>(
  ({ height = '24px', width = '24px' }) => ({
    type: 'checkbox',
    height,
    width,
  })
)<HiddenCheckboxProps>`
  /* remove the checkbox from the page flow, positioning it on top of the SVG */
  position: absolute;
  /* set same dimensions as the SVG */
  width: ${props => props.width};
  height: ${props => props.height};
  /* hide it */
  opacity: 0;
  cursor: pointer;
`;
